import "./styles/global.css";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import "./styles/tailwind.config.js"; // Ensure tailwind config is resolvable or just placeholder
import "./i18n"; // Initialize i18n

ReactDOM.createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
